import { render, staticRenderFns } from "./BoardCard.vue?vue&type=template&id=7a1c5b0e&scoped=true"
import script from "./BoardCard.vue?vue&type=script&lang=js"
export * from "./BoardCard.vue?vue&type=script&lang=js"
import style0 from "./BoardCard.vue?vue&type=style&index=0&id=7a1c5b0e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1c5b0e",
  null
  
)

export default component.exports